import { render, staticRenderFns } from "./CardDiscount.vue?vue&type=template&id=6676667d&scoped=true"
import script from "./CardDiscount.vue?vue&type=script&lang=js"
export * from "./CardDiscount.vue?vue&type=script&lang=js"
import style0 from "./CardDiscount.vue?vue&type=style&index=0&id=6676667d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676667d",
  null
  
)

export default component.exports